import React, {Component} from "react";
import {connect} from "react-redux";
import t from "i18n";
import {setEventDataTableAppTypeFilter} from "../../../actions/actions/eventStats";
import {countEventAppType} from "../../../actions/thunks/eventStats";
import omit from "lodash/omit";
import isEqual from "lodash/isEqual";

@connect(store => ({
  auth: store.auth
}))
class AppTypeFilter extends Component {

  handleAppTypeSelect = (appType) => {
    this.props.setEventDataTableAppTypeFilter(appType);
  };

  componentDidUpdate(nextProps, nextState, nextContext) {
    if (!isEqual(omit(nextProps.eventStatsFilter, ['appType']) , omit(this.props.eventStatsFilter, ['appType']))){
      this.countAppType();
    }
  }

  componentDidMount() {
    this.countAppType();
  }

  countAppType(){
    let params = {};

    if (this.props.eventStatsFilter.search.trim() !== "") {
      params.search = this.props.eventStatsFilter.search;
    }

    if (this.props.eventStatsFilter.year.length > 0) {
      params.year = this.props.eventStatsFilter.year;
    }

    if(this.props.auth.currentClient) {
      params.issuerId = this.props.auth.currentClient.id;
    }


    params.lang = this.props.eventStatsFilter.language;
    params.startMonth = this.props.eventStatsFilter.startMonth;
    params.endMonth = this.props.eventStatsFilter.endMonth;
    params.season = isNaN(this.props.eventStatsFilter.season) ? this.props.eventStatsFilter.season : Number(this.props.eventStatsFilter.season);


    this.props.countEventAppType(params);
  }


  render() {
    const { auth } = this.props;
    
    return (
      <div className={"circles_container"}>
          <ul>
            <li
              className={this.props.eventStatsFilter.appType.includes('registering') ? 'event-filter-app-type-registering selected' : 'event-filter-app-type-registering' }
              onClick={() => this.handleAppTypeSelect(['registering'])}
            >
              <span>{t('TRAININGS')} ({this.props.eventAppType.items.formation})</span>
            </li>
            {
              (auth.currentClient.businessType === 'SUPER_CHAIN' || auth.currentClient.businessType === 'MASTER_CHAIN') && (
              <li
                className={this.props.eventStatsFilter.appType.includes('cycle_registering') ? 'event-filter-app-type-cycle-registering selected' : 'event-filter-app-type-cycle-registering'}
                onClick={() => this.handleAppTypeSelect(['cycle_registering'])}
              >
                <span>{t('CYCLES')} ({this.props.eventAppType.items.cycle})</span>
              </li>
              )
            }
            {this.props.auth.currentClient.businessType === 'SUPER_CHAIN' && (
              <React.Fragment>
                <li
              className={this.props.eventStatsFilter.appType.includes('cycle_essential') ? 'event-filter-app-type-cycle-essential selected' : 'event-filter-app-type-cycle-essential'}
              onClick={() => this.handleAppTypeSelect(['cycle_essential'])}
                >
                  <span>{t('CYCLES_ESSENTIAL')} ({this.props.eventAppType.items.cycle_essential})</span>
                </li>
                <li
                  className={this.props.eventStatsFilter.appType.includes('all_in') ? 'event-filter-app-type-seasons selected' : 'event-filter-app-type-seasons'}
                  onClick={() => this.handleAppTypeSelect(['all_in'])}
                >
                  <span>{t('SEASONS')} ({this.props.eventAppType.items.all_in})</span>
                </li>
                <li
                  className={this.props.eventStatsFilter.appType.includes('congres') ? 'event-filter-app-type-congres selected' : 'event-filter-app-type-congres'}
                  onClick={() => this.handleAppTypeSelect(['congres'])}
                  style={{marginLeft: "10px"}}
                >
                  <span>{t('CONGRESS')} ({this.props.eventAppType.items.congrès})</span>
                </li>
              </React.Fragment>
            )}
          </ul>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  eventStatsFilter: state.filters.eventStatsFilter,
  eventAppType: state.eventAppType,
  auth: state.auth,
});

const mapDispatchToProps = {
  setEventDataTableAppTypeFilter,
  countEventAppType,
};

export default connect(mapStateToProps, mapDispatchToProps)(AppTypeFilter);



// WEBPACK FOOTER //
// ./app/components/Filters/EventStats/AppTypeFilter.js